// extracted by mini-css-extract-plugin
export default {"content-item":"ContentItem_content-item__U5l2X","content-item-image":"ContentItem_content-item-image__LUK9l"};